<template>
  <br />
  <div class="container">
    <div class="row justify-content-center">
      <!-- Columna para dispositivos grandes (md y superiores) -->
      <div class="col-lg-6 col-md-8 order-md-1 mb-4">
        <!-- <div class="rounded p-3 mx-4" style="background-color: #99d8e3">
          <p style="text-align: justify">
            <b>📢 Diplomatura en Tributación Empresarial</b>
          </p>
          <p style="text-align: justify; text-indent: 0px">
            El Consejo Directivo del CCPLL 2024 – 2025 invita a participar en
            esta diplomatura, cuyo objetivo es brindar a los profesionales las
            herramientas necesarias para el cumplimiento adecuado de las
            obligaciones tributarias, asegurando un servicio de calidad y acorde
            con las normativas vigentes.
          </p>
          <p style="text-align: left"> 
            &nbsp; 👨‍🎓 <b>Dirigido a: </b>Miembros de la orden y profesionales
            interesados en especializarse en tributación.<br />
            &nbsp; 📅 Del 13 de octubre al 15 de diciembre de 2025<br />
            &nbsp; 💻 Modalidad virtual <br />
            &nbsp; ⏰ Lunes, miércoles y viernes | 7:00 p.m. – 10:00 p.m.<br />
            &nbsp; 📚 81 horas académicas<br />
            &nbsp; 👉 No pierdas la oportunidad de actualizarte y especializarte
            en un área clave para el ejercicio profesional.<br />
          </p>
          <p style="text-align: left">
            &nbsp; 📅 <b>Inscripciones hasta:</b> Lunes 13 de Octubre<br />
          </p>
          <p style="text-align: center">
            <b>Consejo Directivo 2024-2025</b><br />
            <b>Colegio de Contadores Públicos de La Libertad</b>
          </p>

         

        </div> -->

        <img
          class="flyer"
          src="https://ccpll.org/assets/img/flyers/FIN-DE-AÑO.jpg"
          alt=""
        />
      </div>

      <!-- Columna para dispositivos pequeños (sm y menores) -->
      <div class="col-10 col-lg-5 order-md-2">
        <form @submit.prevent="buscarColegiado">
          <!-- Campos de búsqueda -->
          <div class="mb-3">
            <label for="documento" class="form-label"
              >Documento de Identidad del Miembro de la Orden</label
            >
            <input
              v-model="documento"
              type="text"
              class="form-control"
              id="documento"
              :disabled="docDisabled"
              aria-describedby="documentoHelp"
            />
            <div id="documentoHelp" class="form-text">
              *Recuerda estar hábil para inscribirte
            </div>
          </div>
          <button type="submit" class="btn btn-primary">Buscar</button>
          <br /><br />
          <!-- Campos de información del colegiado (siempre deshabilitados) -->
          <div class="mb-3">
            <label for="nombre" class="form-label">Nombre</label>
            <input
              v-model="nombre"
              type="text"
              class="form-control"
              id="nombre"
              aria-describedby="nombreHelp"
              disabled
            />
          </div>

          <div class="contenido">
            <div class="mb-3">
              <label for="estado" class="form-label">Estado</label>
              <input
                v-model="estado"
                type="text"
                class="form-control"
                id="estado"
                aria-describedby="estadoHelp"
                disabled
              />
            </div>
            <div class="mb-3">
              <label for="codigoColegiado" class="form-label"
                >Codigo Colegiado</label
              >
              <input
                v-model="codigoColegiado"
                type="text"
                class="form-control"
                id="codigoColegiado"
                aria-describedby="codigoColegiadoHelp"
                disabled
              />
            </div>
            <div class="mb-3">
              <label for="celCollegiate" class="form-label">Celular</label>
              <input
                v-model="celular"
                type="text"
                class="form-control"
                id="celCollegiate"
                aria-describedby="celCollegiateHelp"
              />
              <div v-if="celCollegiateError" class="form-text text-danger">
                El celular debe tener 9 dígitos y comenzar con 9.
              </div>
            </div>
            <div class="mb-3">
              <label for="emailCollegiate" class="form-label"
                >Correo Electrónico</label
              >
              <input
                v-model="email"
                type="email"
                class="form-control"
                id="emailCollegiate"
                aria-describedby="emailCollegiateHelp"
              />
              <div v-if="emailCollegiateError" class="form-text text-danger">
                Por favor, ingrese un email electrónico válido.
              </div>
            </div>
          </div>

          <button
            @click.prevent="crearAsistente"
            class="btn btn-success"
            :disabled="!isFormValid"
          >
            > Inscribirse
          </button>
          <button @click.prevent="limpiarCampos" class="btn btn-primary mx-4">
            Limpiar
          </button>

          <div
            class="alert alert-warning alert-dismissible fade show m-3"
            role="alert"
          >
            Cupos Disponibles : {{ cupos }}
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      documento: "",
      docDisabled: false,
      nombre: "",
      estado: "",
      codigoColegiado: "",
      celular: "",
      email: "",
      apiUrl: "",
      cupos: 0,
    };
  },
  computed: {
    celCollegiateError() {
      return !/^9\d{8}$/.test(this.celular); // Valida que el celCollegiate tenga 9 dígitos y comience con 9
    },
    emailCollegiateError() {
      return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email); // Valida que el emailCollegiate sea válido
    },
    isFormValid() {
      return (
        !this.celCollegiateError &&
        !this.emailCollegiateError &&
        this.celular &&
        this.email
      );
    },
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      this.apiUrl = "https://inscripcioneventosapi.ccpll.org/api";
    } else {
      this.apiUrl = "http://localhost:8000/api";
    }
  },
  mounted() {
    this.cuposRestantes();
  },
  methods: {
    cuposRestantes() {
      axios
        .get(`${this.apiUrl}/contarColegiados`)
        .then((response) => {
          this.cupos = 200 - response.data;
        })
        .catch(() => {});
    },
    buscarColegiado() {
      Swal.fire({
        title: "Buscando información...",
        html: "Por favor, espera un momento mientras se buscan los datos.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      axios
        .get(`https://server.ccpll.org/api/listcolegiados/${this.documento}`)
        //.get(`https://admin-ccpll.org/api/v1/colegiado-estado/${this.documento}` )

        .then((response) => {
          const data = response.data;

          if (!data || Object.keys(data).length === 0) {
            Swal.fire("Error", "Colegiado no encontrado.", "error");
            this.limpiarCampos();
            return;
          }

          this.nombre = response.data._DATOS_PERSONALES;
          this.estado = response.data._ESTADO_COLEGIADO;
          this.codigoColegiado = response.data._CODIGO;
          Swal.fire("Éxito", "Información encontrada con éxito.", "success");
          this.docDisabled = true;
        })
        .catch(() => {
          Swal.fire("Error", "No se pudo buscar el colegiado.", "error");
        });
    },
    crearAsistente() {
      if (!this.isFormValid) {
        Swal.fire("Error", "Corrige los errores en el formulario.", "error");
        return;
      }
      Swal.fire({
        title: "Procesando...",
        html: "Por favor, espera un momento.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      axios
        .post(`${this.apiUrl}/crearAsistente`, {
          condicion: this.estado,
          doiCollegiate: this.documento,
          nameCollegiate: this.nombre,
          codigoColegiado: this.codigoColegiado,
          celCollegiate: this.celular,
          emailCollegiate: this.email,
        })
        .then((response) => {
          const msg =
            response.data && response.data.mensaje
              ? response.data.mensaje
              : "Registro realizado con éxito.";
          Swal.fire("Éxito", msg, "success");
          this.limpiarCampos();
        })
        .catch((error) => {
          console.log("axios error: ", error);

          if (error.response && error.response.data) {
            const serverMsg =
              error.response.data.mensaje ||
              error.response.data.message ||
              (error.response.data.errors &&
                JSON.stringify(error.response.data.errors)) ||
              "Error, inténtalo de nuevo.";
            Swal.fire("Error", serverMsg, "error");
          } else if (error.request) {
            Swal.fire("Error", "No se pudo completar el registro.", "error");
          } else {
            Swal.fire(
              "Error",
              "Ocurrió un error al procesar la petición.",
              "error"
            );
          }

          // Swal.fire("Error", "No se pudo completar el registro.", "error");
        });
    },
    limpiarCampos() {
      this.documento = "";
      this.nombre = "";
      this.estado = "";
      this.codigoColegiado = "";
      this.celular = "";
      this.email = "";
      this.docDisabled = false;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
}

.container {
  padding-bottom: 2rem;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.contenido {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-control {
  font-size: 13px !important;
}

.flyer {
  max-height: 600px;
  align-content: center;
}
/* 
@media (min-width: 960px) {
  .container {
    grid-column: 1;
  }
} */
</style>
